import React, {useRef, useEffect, memo} from 'react';
import Placeholder from "./Placeholder";

const ProductCellBanner = memo(({
                               listItemToDisplay,
                               apiStatusPending,
                               isPaginationLoading,
                               listType,
                               isAutoPromoBanners
                           }) => {
    const bannerRef = useRef();
    useEffect(() => {

        if (bannerRef.current && isAutoPromoBanners && listType != 'grid' ) {
            bannerRef.current.firstElementChild.classList.add(isAutoPromoBanners);
        }
    }, [bannerRef.current]);
    return (
        <>
            {apiStatusPending && isPaginationLoading === false ?
                <Placeholder mea={"banner"} isAutoPromoBanners={isAutoPromoBanners} apiStatusPending={apiStatusPending}
                             listType={listType}
                /> :
                (listType === 'grid') ?
                    <span className={`product-banner${isAutoPromoBanners ? ' ' + isAutoPromoBanners : ''}`}
                          dangerouslySetInnerHTML={{__html: listItemToDisplay.value}}/> :
                    <span className={`product-banner${isAutoPromoBanners ? ' ' + isAutoPromoBanners : ''}`} ref={bannerRef}
                          dangerouslySetInnerHTML={{__html: listItemToDisplay.value}}/>
            }
        </>
    )
})

export default ProductCellBanner;